import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Container from '@hzero-front-ui/core/lib/Container';
import LayoutTheme from "../../components/UedTheme";
var DefaultContainer = function DefaultContainer(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, ["children"]);
  return /*#__PURE__*/React.createElement(Container, rest, /*#__PURE__*/React.createElement(LayoutTheme, null), children);
};
export default DefaultContainer;